var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default').default;

(function () {
  Motion.file('main.js', function (require) {
    var _keycode = require('keycode');

    var _keycode2 = _interopRequireDefault(_keycode);

    window.___keycode = _keycode2.default;

    var keysCorrect = function keysCorrect(_ref) {
      var altKey = _ref.altKey;
      var metaKey = _ref.metaKey;
      return altKey && !metaKey;
    };

    var offAlt = null;
    function checkInspect(e) {
      if (keysCorrect(e)) {
        // wait a little so were not toooo eager
        offAlt = on.delay(180, function () {
          if (keysCorrect(e)) {
            on.event('hud:show');
          }
        });
      } else {
        offAlt && offAlt();
        on.event('hud:hide');
      }
    }

    on.keydown(window, checkInspect);
    on.keyup(window, checkInspect);

    Motion.staticStyles('Main', {
      '$': '#_motiondevtools .ViewMain'
    }, {
      '$': {
        position: 'fixed',

        top: 0, left: 0,
        right: 0, bottom: 0,
        zIndex: 2147483647
      }
    });
    Motion.view('Main', function (view, on, $) {
      var internal = window.__isDevingDevTools;
      var showInspector = true;view.render(function () {
        return view.el(['link', 1], { rel: 'stylesheet', property: 'stylesheet', href: '/__/tools/static/tools.css' });
      });view.render(function () {
        return Motion.iff(!internal) && view.el(['link', 2], { if: !internal, rel: 'stylesheet', property: 'stylesheet', href: '/__/tools/styles.css' });
      });view.render(function () {
        return view.el(['Errors', 1], null);
      });view.render(function () {
        return view.el(['Installer', 1], null);
      });view.render(function () {
        return view.el(['DevBar', 1], null);
      });view.render(function () {
        return Motion.iff(showInspector) && view.el(['Menu', 1], { if: showInspector });
      });view.render(function () {
        return Motion.iff(showInspector) && view.el(['Inspector', 1], { if: showInspector });
      });view.render(function () {
        return Motion.iff(internal) && view.el(['StateTests', 1], { if: internal });
      });

      $["$"] = function (_, _index) {
        return { pointerEvents: internal ? 'auto' : 'none' };
      };
    });
  })
})();
//# sourceMappingURL=main.js.map
